import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Outlet } from 'react-router-dom';
import Header from '@Components/Header/Header';
import SettingsDialog from '@Components/Settings/SettingsDialog';
import { SettingsType } from '@Components/Settings/SettingsType';
import AdminApi from '@Data/administration/Api';
import OrganizationsApi from '@Data/organizations/Api';
import {
    activeOrganizationsState,
    selectedOrganizationState,
} from '@Data/organizations/Reducer';
import { SettingsApi } from '@Data/settings/Api';
import { isSettingsOpenState, settingsTypeState } from '@Data/settings/Reducer';
import TeamsApi from '@Data/teams/Api';
import { activeTeamsState, selectedTeamState } from '@Data/teams/Reducer';

const RootBaseView = () => {
    const params = useParams();
    const organizationId = params.organizationId;
    const teamId = params.teamId;

    const activeOrganizations = useSelector(activeOrganizationsState);
    const selectedOrganization = useSelector(selectedOrganizationState);

    const activeTeams = useSelector(activeTeamsState);
    const selectedTeam = useSelector(selectedTeamState);

    const isSettingsOpen = useSelector(isSettingsOpenState);
    const selectedSettingsType = useSelector(settingsTypeState);

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    useEffect(() => {
        AdminApi.getIsUserSuperAdmin();
    }, []);

    useEffect(() => {
        if (_isNil(activeOrganizations)) {
            OrganizationsApi.getOrganizations();
        }
    }, [activeOrganizations]);

    useEffect(() => {
        if (!_isNil(activeOrganizations) && _isNil(selectedOrganization)) {
            const selectedOrg = !_isNil(organizationId)
                ? activeOrganizations.find(
                      (o) => o.organisation_id === organizationId
                  )
                : activeOrganizations[0];
            OrganizationsApi.setSelectedOrganization(selectedOrg);
        }
    }, [organizationId, selectedOrganization, activeOrganizations]);

    useEffect(() => {
        if (!_isNil(selectedOrganization) && _isNil(activeTeams)) {
            TeamsApi.getOrganizationTeams(selectedOrganization.organisation_id);
        }
    }, [selectedOrganization, activeTeams]);

    useEffect(() => {
        if (!_isNil(activeTeams) && _isNil(selectedTeam)) {
            const selectedTeam = !_isNil(teamId)
                ? activeTeams.find((t) => t.team_id === teamId)
                : activeTeams[0];
            TeamsApi.setSelectedTeam(selectedTeam);
        }
    }, [teamId, selectedTeam, activeTeams]);

    const onSettingBtnClick = (settingsType: SettingsType) => {
        SettingsApi.openSettings(settingsType);
    };

    const onSettingsClose = () => {
        SettingsApi.closeSettings();
    };

    return (
        <React.Fragment>
            <Header
                onSettingBtnClick={onSettingBtnClick}
                isSettingsOpen={isSettingsOpen}
                selectedSettingsType={selectedSettingsType}
                isSubmitting={isSubmitting}
            />
            <Outlet />
            <SettingsDialog
                isOpen={isSettingsOpen}
                onClose={onSettingsClose}
                type={selectedSettingsType}
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
            />
        </React.Fragment>
    );
};

export default RootBaseView;
